/**
 * @module "behavior/base.drag.drop.with.target.behavior"
 * @description Behavior that allows to drag and drop items from current view into the target view.
 * target is a jQuery selector for the view that has been set up as container for
 * drag and drop.
 */
define('formkit/behavior/base.drag.drop.with.target.behavior',['require','exports','module','underscore','marionette','dragula','bluebird','backbone.radio'],function(require, exports, module) {
  //prettier-ignore
  var _       = require('underscore'),
      Mn      = require('marionette'),
      dragula = require('dragula'),
      Promise = require('bluebird'),
      Radio   = require('backbone.radio');

  /**
   * @method makeMovesCb
   * @todo This could use more documentation
   * @param  {type} _dragHandle
   * @returns {boolean}
   */
  function makeMovesCb(_dragHandle) {
    function movesCb(el, source, target) {
      var dragHandle = _dragHandle || '.drag-handle';
      return $(target).closest(dragHandle).length > 0;
    }
    return movesCb;
  }

  /**
   * @method acceptsCb
   * @todo This could use more documentation. I'm not sure what to put for
   * the types
   * @param  {type} el
   * @param  {type} target
   * @param  {type} source
   * @param  {type} sibling
   * @returns {boolean}
   */
  function acceptsCb(el, target, source, sibling) {
    // If element being dragged contains the new source,
    if (el.contains(target)) {
      // don't allow element to be dropped
      return false;
    }
    return true;
  }

  /**
   * @class BaseDragDropWithTargetBehavior
   * @augments external:Mn.Behavior
   * @property {Object} defaults - an object containing defaults for dragDropInstanceName,
   * target, useDragHandler, dragHandle, isContainer, allowDefaultDragulaDropAction,
   *  allowMultipleDragDropHandlers, and onDrakeDrop();
   * @property {string} eventNamespace - 'drake'
   */

  var BaseDragDropWithTargetBehavior = Mn.Behavior.extend({
    defaults: {
      dragDropInstanceName: null,
      target: null,
      useDragHandler: false,
      dragHandle: null,
      isContainer: false,
      allowDefaultDragulaDropAction: false,
      allowMultipleDragDropHandlers: false,

      onDrakeDrop: function(elView, targetView, sourceView, siblingView) {},
    },

    eventNamespace: 'drake',

    initialize: function() {
      this.setupDragulaOrLinkExistingDragula(dragula);

      this.listenToOnce(this.view, 'render', function() {
        this.setupContainers();
        if (!this.options.isContainer) {
          this.setupEvents();
        }
      });

      this.setupViewData();
    },

    setupDragulaOrLinkExistingDragula: function(dragula) {
      if (this.options.dragDropInstanceName) {
        this.drake = Radio.request(this.options.dragDropInstanceName, 'drake');

        if (!this.drake) {
          this.drake = this.setupDragula(dragula);
          Radio.reply(this.options.dragDropInstanceName, 'drake', this.drake);
        }
      } else {
        this.drake = this.setupDragula(dragula);
      }
    },

    setupDragula: function(dragula) {
      var options = {},
        drake = null;

      if (this.getOption('useDragHandler')) {
        options.moves = makeMovesCb(this.getOption('dragHandle'));
      }

      // Default option.accepts callback
      if (!this.getOption('accepts')) {
        options.accepts = acceptsCb;
      }

      drake = dragula([], options);

      return drake;
    },

    setupContainers: function() {
      if (!this.drake.containers) {
        this.drake.containers = [];
      }
      this.drake.containers.push(this.getViewContainerDomEl(this.view));
    },

    getViewContainerDomEl: function(view) {
      var container = null;

      // If a composite view, retrieve the childViewContainer element
      if (view instanceof Mn.CompositeView) {
        container = view.$(view.childViewContainer)[0];

        // If a collection view, retrieve the main element
      } else if (view instanceof Mn.CollectionView) {
        container = view.$el[0];
      }

      return container;
    },

    /**
     * Re-emit events on the behavior
     * @return void
     */
    setupEvents: function() {
      var eventTypesToListenTo = ['drop'];

      // for each event, re-emit on this behavior, so can use onDrakeDrop etc
      _.each(
        eventTypesToListenTo,
        function(eventType) {
          var self = this;

          var callback = function() {
            var args = _.toArray(arguments);
            args.splice(0, 0, self.eventNamespace + ':' + eventType);
            self.triggerMethod.apply(self, args);
          };

          // remove event first to prevent unwanted duplication of events unless otherwise specified
          if (!this.options.allowMultipleDragDropHandlers) {
            this.drake.off(eventType, callback);
          }
          this.drake.on(eventType, callback);
        },
        this
      );
    },

    onDrakeDrop: function(el, target, source, sibling) {
      // cancel default dragula drop action unless it is explicitly set to true
      if (!this.options.allowDefaultDragulaDropAction) {
        this.drake.cancel(true);
      }

      var elView = this.getViewDataFromDomElement(el),
        targetView = this.getViewDataFromDomElement(target),
        sourceView = this.view,
        siblingView = this.getViewDataFromDomElement(sibling);

      if (!targetView) {
        Promise.reject(new Error('Target view has not been set up as a drag drop container.'))
               .catch(function(error) {
                console.error('Error onDrakeDrop targetView:', error);
               });
        return;
      }

      this.options.onDrakeDrop(elView, targetView, sourceView, siblingView);
    },

    getViewDataFromDomElement: function(domElement) {
      return $(domElement).data('view');
    },

    setupViewData: function() {
      this.listenToOnce(this.view, 'render', function() {
        $(this.getViewContainerDomEl(this.view)).data('view', this.view);
      });

      this.listenTo(this.view, 'add:child', function(childView) {
        childView.$el.data('view', childView);
      });
    },
  });

  module.exports = BaseDragDropWithTargetBehavior;
});

